module.exports = __webpack_public_path__ + "img/05.ad5f7cbe.jpg";